export default {
  'MENU_STATUS_DISPLAY':'MENU_STATUS_DISPLAY',
  'MENU_STATUS_REMOVE':'MENU_STATUS_REMOVE',
};


// WEBPACK FOOTER //
// ./modules/menu/constants/StatusConstants.js